import { useContext } from "react";
import { ThemeContext } from "./ThemeContext";
export var useTheme = function useTheme() {
  var _useContext = useContext(ThemeContext),
    type = _useContext.type,
    theme = _useContext.theme;
  return {
    type: type,
    theme: theme
  };
};